import type { ComponentProps } from 'react';
import { cn } from '@/shared/lib/utils';
import { useEffect } from 'react';
import { useBottomTab } from '@/shared/contexts/bottom-tab-context';

export type AppLayoutProps = ComponentProps<'div'> & {
  children: React.ReactNode;
  hideBottomTabShadow?: boolean;
  hideBottomTab?: boolean;
};

export function AppLayout({
  children,
  className,
  hideBottomTabShadow = false,
  hideBottomTab = false,
}: AppLayoutProps) {
  const { setHideBottomTab, setHideBottomTabShadow } = useBottomTab();

  // Update bottom tab visibility based on props
  useEffect(() => {
    setHideBottomTab(hideBottomTab);
    setHideBottomTabShadow(hideBottomTabShadow);
  }, [hideBottomTab, hideBottomTabShadow, setHideBottomTab, setHideBottomTabShadow]);

  return (
    <div className="flex flex-col h-[100dvh] w-full relative overflow-hidden">
      {/** Conteúdo */}
      <div
        className={cn(
          'flex flex-col items-center w-full flex-1 overflow-y-auto overflow-x-hidden hide-scrollbar',
          'pt-16 pb-[calc(5rem+env(safe-area-inset-bottom))]',
          className
        )}
        data-scroll-container
      >
        {children}
      </div>
    </div>
  );
}
